import {
  Mtds,
  TopBar,
  AppLayout,
  ArrowLeftIcon,
  TestTubeIcon,
  Sample,
  AnimatedCheckMark,
  getFirstRequisition,
  HashIcon,
  useAllSamples,
  SampleShippingAddress
} from 'prove-common'
import { AppLogo } from '../components/app-logo/AppLogo'
import { useLocation } from 'react-router'

export const SamplesMarkedAsSentScreen = () => {
  const location = useLocation()
  const sampleIds: string[] = location.state?.sampleIds ?? []
  const {
    samples: updatedSamples,
    isLoading: isPending,
    isError
  } = useAllSamples({
    isEnabled: sampleIds.length > 0,
    sampleIds
  })

  const handleTilbake = () => {
    globalThis.location.replace('/home')
  }

  const breadcrumbItems = [
    {
      label: 'Hjem',
      to: '/home'
    },
    {
      label: 'Prøver merket som sendt'
    }
  ]

  return (
    <AppLayout
      topBar={<TopBar logo={<AppLogo />} breadcrumbItems={breadcrumbItems} />}
      isLoading={isPending && !isError}
      isError={isError}
    >
      <Mtds.Grid data-justify='center' data-color='success'>
        <AnimatedCheckMark />
        <Mtds.Muted>
          {new Date().toLocaleDateString('no-NO', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
        </Mtds.Muted>
        {updatedSamples.length === 1 ? (
          <Mtds.Heading as='h1' data-size='md'>
            1 prøve sendt
          </Mtds.Heading>
        ) : (
          <Mtds.Heading as='h1' data-size='md'>
            {updatedSamples?.length} prøver sendt
          </Mtds.Heading>
        )}
      </Mtds.Grid>
      <Mtds.Table data-align='center'>
        <thead>
          <tr>
            <th>Pose</th>
            <th>Produkt</th>
            <th>Prøve av</th>
            <th>Laboratorium</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {updatedSamples?.map((sample: Sample) => {
            const requisition = getFirstRequisition(sample)
            return (
              <tr key={sample.id}>
                <td>
                  <Mtds.Flex data-align='center' data-gap='1'>
                    <HashIcon />
                    <strong>{sample.id}</strong>
                  </Mtds.Flex>
                </td>
                <td>{sample.sampleType.product}</td>
                <td>{sample.sampleType.matrix}</td>
                <td>
                  <Mtds.Grid data-gap='1'>
                    {sample.shippingAddress?.labName ??
                      requisition?.lab.name ??
                      '-'}
                    <SampleShippingAddress
                      address={sample.shippingAddress}
                      showName={false}
                    />
                  </Mtds.Grid>
                </td>
                <td style={{ width: '1%', whiteSpace: 'nowrap' }}>
                  <TestTubeIcon />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Mtds.Table>
      <Mtds.Flex>
        <Mtds.Button
          data-variant='secondary'
          onClick={handleTilbake}
          style={{ width: '100%' }}
        >
          <ArrowLeftIcon />
          Tilbake til hjem
        </Mtds.Button>
      </Mtds.Flex>
    </AppLayout>
  )
}
